import { useState } from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Faq.css';

function Faq() {
  const faqs = [
    {
      question: 'What personal training services do you offer?',
      answer:
        'Lu - Fit offers one-on-one personal training, small group sessions, online coaching, nutrition guidance, and strength and conditioning programs tailored to your goals.'
    },
    {
      question: 'Do I need to be fit to start training?',
      answer:
        'Not at all! Whether you’re a beginner or returning after a break, our programs are adapted to your current fitness level.'
    },
    {
      question: 'Where are the training sessions held?',
      answer:
        'Sessions are conducted in Cape Town at local gyms, parks, or at your home, depending on your preference and package.'
    },
    {
      question: 'What should I bring to a training session?',
      answer:
        'Wear comfortable workout clothes, bring a towel and water bottle. We provide basic training equipment unless otherwise discussed.'
    },
    {
      question: 'Do you offer online coaching?',
      answer:
        'Yes, we offer fully remote training programs and video check-ins for those who prefer to train from home.'
    },
    {
      question: 'How do I book a session?',
      answer:
        'You can book via our Contact page, email, or phone. We’ll respond within 24 hours to confirm availability.'
    },
    {
      question: 'Can I train with a friend or partner?',
      answer:
        'Absolutely! We offer discounted rates for small group training (2–3 people).'
    },
    {
      question: 'What is your cancellation policy?',
      answer:
        'Cancellations should be made at least 12 hours before your session. Late cancellations may incur a charge.'
    },
    {
      question: 'Do you help with nutrition planning?',
      answer:
        'Yes, we offer basic meal guidance and habit coaching to support your fitness goals, with referral options for specialized nutrition plans.'
    },
    {
      question: 'What if I have a previous injury?',
      answer:
        'We’ll tailor your training plan to safely accommodate injuries or mobility restrictions. Always consult your doctor first.'
    }
  ];

  const [open, setOpen] = useState(faqs.map(() => false));
  const toggleFAQ = (index) => {
    setOpen((prev) =>
      prev.map((state, i) => (i === index ? !state : state))
    );
  };

  return (
    <section
      className="faq-section"
      id="faq"
      aria-labelledby="faq-heading"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <Helmet>
        <title>FAQs | Lu - Fit Personal Training Cape Town</title>
        <meta
          name="description"
          content="Got questions about personal training in Cape Town? See answers to our most frequently asked questions at Lu - Fit."
        />
      </Helmet>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div className="faq-item" itemProp="mainEntity" itemScope itemType="https://schema.org/Question" key={index}>
            <h3>
              <button
                className={`faq-question ${open[index] ? 'is-open' : ''}`}
                aria-expanded={open[index]}
                aria-controls={`faq-answer-${index}`}
                id={`faq-question-${index}`}
                onClick={() => toggleFAQ(index)}
                itemProp="name"
              >
                {faq.question}
                <span className="faq-toggle" aria-hidden="true">
                  {open[index] ? '−' : '+'}
                </span>
              </button>
            </h3>
            {open[index] && (
              <div
                id={`faq-answer-${index}`}
                className="faq-answer"
                role="region"
                aria-labelledby={`faq-question-${index}`}
                itemProp="acceptedAnswer"
                itemScope
                itemType="https://schema.org/Answer"
              >
                <p itemProp="text">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Faq;
